import { Input } from '@nimbus-ds/components';
import useTranslationPreOnboarding from 'domains/PreOnboarding/useTranslationPreOnboarding';
import './TaskInputCard.scss';

interface TaskInputCardProps {
  freeText: string;
  onChange: (value: string) => void;
  label: string;
}

export function TaskInputCard({
  freeText,
  onChange,
  label,
}: Readonly<TaskInputCardProps>) {
  const t = useTranslationPreOnboarding();

  return (
    <div className="stratus--task-input-card">
      <Input
        append={label}
        appendPosition="start"
        value={freeText}
        placeholder={t(`questionnaire.which`)}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
